module.exports = __webpack_public_path__ + "img/instagram.fe75b5af.svg";